import "./SubtasksStatus.css";

export interface ISubtasksStatus {
    failed?: number;
    success?: number;
    running?: number;
    total?: number;
}

const SubtasksStatus = ({ failed, success, running, total }: ISubtasksStatus) => {
    return (
        <div id="div-subtasksstatus" className="subtasks">
            <label id="label-subtasks-failed" className="subtasks-failed">{failed}</label>
            &nbsp;/&nbsp;
            <label id="label-subtasks-completed" className="subtasks-completed">{success}</label>
            &nbsp;/&nbsp;
            <label id="label-subtasks-running" className="subtasks-running">{running}</label>
            &nbsp;/&nbsp;
            <label id="label-subtasks-total" className="subtasks-total">{total}</label>
        </div>
    );
};

export default SubtasksStatus;
